import { customBatchGetProducts } from "@iewcasia/Services/CustomProductService";
import { setGA4Event } from "@iewcasia/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteBatchLoadProducts,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";
import { CartLineModel, ProductDto } from "@insite/client-framework/Types/ApiModels";

replaceInChain(chain, RequestDataFromApi, async props => {
    props.result.apiResult = await customBatchGetProducts(props.result.apiParameter);
});

addToChainAfter(chain, DispatchCompleteBatchLoadProducts, props => {
    if (props.result.apiResult.length > 0) {
        setGA4Event(props?.result?.apiResult as ProductDto[], "add_to_cart");
    }
});